import { recaptchaKeys } from '../../constants';

Vue.component('recaptcha-check', {
  template: `
    <div
      id="vue-recap"
      data-badge="bottomright"
      data-size="invisible"
      :data-sitekey="sitekey">
    </div>
  `,

  // need to mutate status prop
  data() {
    return {
      sitekey: recaptchaKeys,
      widgetId: 0,
    }
  },

  /**
   * Methods object
   */
  methods: {
    createRecaptcha() {
      window.vueRecaptchaApiLoaded = this.render;
      const script = document.createElement('script');
      script.async = true;
      script.setAttribute('src', 'https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit');
      document.getElementsByTagName('head')[0].appendChild(script);
    },

    execute() {
      window.grecaptcha.execute(this.widgetId);
    },

    reset() {
      window.grecaptcha.reset(this.widgetId);
    },

    render() {
      if (window.grecaptcha.render) {
        this.widgetId = window.grecaptcha.render('vue-recap', {
          sitekey: this.sitekey,
          size: 'invisible',
          // the callback executed when the user solve the recaptcha
          callback: (response) => {
            // emit an event called verify with the response as payload
            this.$emit('verify', response);
            // reset the recaptcha widget so you can execute it again
            this.reset();
          },
        });
      }
    },
  },

  mounted() {
    Vue.nextTick(() => {
      this.createRecaptcha();
      // this.render();
    });
  },
});



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/shared/vue/components/recaptcha.js